<template>
  <li class="px-4 py-2 border-b border-gray-200 w-full hover:bg-gray-100 hover:text-gray-800"><a
      :href="`/static/pdf/${department}/syllabus/${list.year}/${list.file}`"
      target="_blank">{{ list.title }}</a>
  </li>
</template>

<script>
export default {
  name: "SyllabusList",
  props: {
    list: {
      type: Object
    },
    department: {
      type: String
    }
  }
}
</script>

<style scoped>

</style>
